import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import { ownerOptionList, captainOptionList, mateOptionList } from "../../refs/lists";
import './Modal.css';

const EditAnglerModal = (props) => {

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [boatName, setBoatName] = useState();
  const [isOwner, setIsOwner] = useState();
  const [isCaptain, setIsCaptain] = useState();
  const [isMate, setIsMate] = useState();
  const [boatList, setBoatList] = useState([]);

  const delayRefresh = () => {
    setTimeout(() => {
      window.location.reload(false);
    }, 2000);
  }

  const validateAndSubmitUserInput = () => {

    // Update boat record
    let anglerOptions = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/updateAngler',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        id: props.selectedRow[0].id,
        firstName: firstName,
        lastName: lastName,
        boatName: boatName,
        owner: isOwner,
        captain: isCaptain,
        mate: isMate
      })
    }
    const updateAngler = async () =>{
      let response = await axios(anglerOptions);
      toast.success("Successfully updated angler status. Please wait while table refreshes.")
    }
    updateAngler();
    delayRefresh();
  }

  useEffect(() => {
    // Get boat list
    const fetchRegisteredBoatsFromDatabase = async () => {
      let params = {
        method: 'GET',
        url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllBoats',
        headers: {'Content-Type': 'application/json'},
      }
      let response = await axios(params);
      let responseList = []
      if (response.data) {
        response.data.forEach((entry) => {
          responseList.push(entry)
        })
      }
      setBoatList(responseList);
    }
    fetchRegisteredBoatsFromDatabase();

    const anglerToBeEdited = props.selectedRow[0];
    setFirstName(anglerToBeEdited['firstName']);
    setLastName(anglerToBeEdited['lastName']);
    setBoatName(anglerToBeEdited['boatName']);
    setIsOwner(anglerToBeEdited['owner']);
    setIsCaptain(anglerToBeEdited['captain']);
    setIsMate(anglerToBeEdited['mate']);
  }, []);

  return (
    <>
      <div className="modal">
        <div onClick={props.toggleModal} className="overlay"></div>
        <div className="modal-content">
          <h2>Edit Angler Entry</h2>
          <label>*Boat: </label>
          <select value={boatName} onChange={(e) => setBoatName(e.target.value)}>
            {boatList.map((boatOption, i) => {
              if (boatOption.boatName == boatName) {
                return <option key={i} value={boatOption.boatName} selected="selected">{boatOption.boatName}</option>
              } else {
                return <option key={i} value={boatOption.boatName} >{boatOption.boatName}</option>
              }
            })}
          </select>
          <br/>
          <br/>
          <label>*Angler: </label>
          <input placeholder="First name" type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)}></input> 
          <input placeholder="Last name" type="text" value={lastName} onChange={(e) => setLastName(e.target.value)}></input>
          <br/>
          <br/>
          <label>Owner? </label>
          <select value={isOwner} onChange={(e) => setIsOwner(e.target.value)}>
            {ownerOptionList.map((ownerOption, i) => {
              if (ownerOption == isOwner) {
                return <option key={i} value={ownerOption} selected="selected">{ownerOption}</option>
              } else {
                return <option key={i} value={ownerOption} >{ownerOption}</option>
              }
            })}
          </select>
          <label>Captain? </label>
          <select value={isCaptain} onChange={(e) => setIsCaptain(e.target.value)}>
            {captainOptionList.map((captainOption, i) => {
              if (captainOption == isCaptain) {
                return <option key={i} value={captainOption} selected="selected">{captainOption}</option>
              } else {
                return <option key={i} value={captainOption} >{captainOption}</option>
              }
            })}
          </select>
          <label>Mate? </label>
          <select value={isMate} onChange={(e) => setIsMate(e.target.value)}>
            {mateOptionList.map((mateOption, i) => {
              if (mateOption == isMate) {
                return <option key={i} value={mateOption} selected="selected">{mateOption}</option>
              } else {
                return <option key={i} value={mateOption} >{mateOption}</option>
              }
            })}
          </select>
          <br/>
          <br/>
          <button className="btn-modal" onClick={validateAndSubmitUserInput} type="button">Submit</button>
          <button className="close-modal" onClick={props.toggleModal}>CLOSE</button>
        </div>
      </div>  
    </>
  );
}

export default EditAnglerModal;

